/**
 * Aplicación web Directorio del Ayuntamiento de Zamora.
 * 
 * Desarrollo e implementación: Jaime León Pereira.
 * Ingeniero Informático de la Unidad TIC.
 */
import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useNavigate } from "react-router-dom"; 
import "../../styles/Sidebar.css";

/**
 * Componente de barra lateral de navegación.
 * 
 * Barra lateral responsiva que permite navegar entre las diferentes
 * secciones de la aplicación. Se adapta a diferentes dispositivos:
 * - Escritorio: Barra lateral fija
 * - Móvil/Tablet: Offcanvas
 * 
 * Incluye enlace al panel de administración para usuarios con permisos.
 */

const Sidebar = ({ activeSection, setActiveSection, user, isAdmin, isMobile, isTablet }) => {

  const goToSection = (section) => {
    if (activeSection === section) {
      setActiveSection(null);
      setTimeout(() => setActiveSection(section), 0);
    } else {
      setActiveSection(section);
    }
  };

  // Hook para navegación programática
  const navigate = useNavigate(); 

  /* ============================
     Componente de botón reutilizable
     ============================ */
  
  /**
   * Componente interno para botones de navegación.
   */
  const Button = ({ id, icon, label, onClick }) => (
    <button
      className={`sidebar-btn ${activeSection === id ? "active" : ""} `}
      onClick={onClick}
    >
      <i className={`bi ${icon}`}></i>
      <span>{label}</span>
    </button>
  );

  /*************************************************************
   *             Renderizado de la barra lateral               *
   *************************************************************/
  return (
    /* 
     * Contenedor principal con clases condicionales según dispositivo
     * - Móvil/Tablet: Ocupa todo el ancho y alto
     * - Escritorio: Columna de 3/12 (25%) del grid Bootstrap
     */
    <div className={`
      ${(isMobile || isTablet) ? "w-100 h-100" : "col-md-3"} 
      rounded d-flex flex-column flex-shrink-0 p-3 text-bg-dark`} >
      
      {/* Título del menú */}
      <h5 className="mb-3 text-center text-white">Menú</h5>
      
      {/* =============================
          Lista de navegación principal 
          ============================= */}
      <ul className={`nav nav-pills flex-column mb-auto flex-grow-1 w-100}`}>
         
         {/* === Botón: Nueva búsqueda === */}
         <li>
          <Button
            id="busqueda"
            icon="bi-search"
            label="Nueva búsqueda"
            onClick={() => setActiveSection("busqueda")}
          />
        </li>

        {/* === Botón: Departamentos === */}
        <li className="nav-item">
          <Button
            id="departamentos"
            icon="bi-folder"
            label="Departamentos"
            onClick={() => goToSection("departamentos")}
          />
        </li>

        {/* === Botón: Edificios === */}
        <li className="nav-item">
          <Button
            id="edificios"
            icon="bi-building"
            label="Edificios"
            onClick={() => goToSection("edificios")}
          />
        </li>

        {/* === Botón: Ayuda (posición automática inferior) === */}
        <li className="nav-item mt-auto">
          <Button
            id="ayuda"
            icon="bi-question-circle"
            label="Ayuda"
            onClick={() => setActiveSection("ayuda")}
          />
        </li>

         {/* === Botón: Administrador (solo para usuarios admin) === */}
        {isAdmin &&(
          <li className="nav-item mt-2">
            <Button
              id="login"
              icon="bi-person-lock"
              label="Administrador"
              onClick={() => navigate("/admin/dashboard")}
            />
          </li>
        )}
      </ul>
    </div>
  );
}

export default Sidebar;